export function isPressed(button: HTMLButtonElement): boolean {
  return button.getAttribute('aria-pressed') === 'true';
}

export function setPressed(button: HTMLButtonElement, pressed: boolean): void {
  button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
}

export function togglePressed(button: HTMLButtonElement): void {
  setPressed(button, !isPressed(button));
}

export function readValues(buttons: HTMLButtonElement[]): number[] {
  return buttons.filter(isPressed).map((button) => Number(button.dataset.value));
}

export function applyValues(buttons: HTMLButtonElement[], values: number[]): void {
  const selected = values.map(Number);

  buttons.forEach((button) => {
    setPressed(button, selected.includes(Number(button.dataset.value)));
  });
}

export function readWeeks(buttons: HTMLButtonElement[]): Record<string, number[]> {
  const weeks: Record<string, number[]> = {};

  buttons.forEach((button) => {
    if (!isPressed(button)) return;

    const day = button.dataset.day;
    if (!day) return;

    weeks[day] ??= [];
    weeks[day].push(Number(button.dataset.ordinal));
  });

  return weeks;
}

export function applyWeeks(buttons: HTMLButtonElement[], weeks: Record<string, number[]>): void {
  buttons.forEach((button) => {
    const ordinals = weeks[button.dataset.day ?? ''] ?? [];
    const ordinal = Number(button.dataset.ordinal);
    setPressed(button, ordinals.map(Number).includes(ordinal));
  });
}
